module.exports = __webpack_public_path__ + "img/meraik.16b3b7b2.jpg";